angular.module('ihestiaRestServicesBase')
  .factory('ihestiaRestVehicleDictionaryTypesSvc', ['ihestiaRestAbstractVehicleDictionariesSvc',
    function(ihestiaRestAbstractVehicleDictionariesSvc) {

      var RestDictionaryVehicleSvc = function() {
        ihestiaRestAbstractVehicleDictionariesSvc.apply(this, arguments);

        this.id = 'types';

      };
      return new RestDictionaryVehicleSvc();
    }
  ]);